<template>
  <div
    v-if="organization.org_id"
  >
    <b-card-header>
      <b-card-title>
        <feather-icon
          icon="ChevronLeftIcon"
          class="cursor-pointer mr-1 btn-link"
          size="16"
          @click="$emit('clearOrganization')"
        />
        {{ $t('Number of doctoral students in the direction of organization') }}
      </b-card-title>
    </b-card-header>
    <!-- chart -->
    <b-table
      :items="countByApplyDocResearcherOrganizationDirection"
      responsive
      :fields="fields"
      class="mb-0"
      :per-page="perPage"
      :current-page="currentPage"
    >
      <template #head()="data">
        {{ getHead(data) }}
      </template>

      <template #cell(index)="data">
        {{ (currentPage - 1) * perPage + data.index + 1 }}
      </template>

      <template #cell(name)="data">
        {{ $langName(data.value) }}
      </template>
    </b-table>
    <div class="mb-1 mr-1">
      <b-row>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="12"
          class="d-flex align-items-end justify-content-end justify-content-sm-end"
        >

          <b-pagination
            v-model="currentPage"
            :total-rows="total"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import {
  BCardHeader, BCardTitle, BTable, BPagination, BRow, BCol,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'

export default {
  name: 'OrgCountByTypeAndOrgAdminComponent',
  components: {
    BCardHeader,
    BCardTitle,
    BTable,
    BPagination,
    BRow,
    BCol,
  },
  props: {
    organization: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
    }
  },
  computed: {
    countByApplyDocResearcherOrganizationDirection() {
      return this.$store.state[this.MODULE_NAME].countByApplyDocResearcherOrganizationDirection
    },
  },
  created() {
    this.$store.dispatch(`${this.MODULE_NAME}/countByApplyDocResearcherOrganizationDirection`, this.organization.org_id).then(res => {
      this.total = res.data.length
    })
  },
  methods: {
    getDcType(id) {
      return this.$store.getters['staticModule/getDcType'](Number(id))
    },
    getHead(head) {
      const col = head.column
      if (Number(col) >= 100 && Number(col) <= 700) {
        return this.$langName(this.getDcType(col).name)
      }
      return this.$t(head.label)
    },
  },
  setup() {
    const fields = [
      { key: 'index', label: '#' },
      { key: 'name', label: 'Direction', thClass: 'h6' },
      { key: '100', thClass: 'h6' },
      { key: '200', thClass: 'h6' },
      { key: '300', thClass: 'h6' },
      { key: '400', thClass: 'h6' },
      { key: '500', thClass: 'h6' },
      { key: '600', thClass: 'h6' },
      { key: '700', thClass: 'h6' },
      { key: 'total', label: 'Total', thClass: 'h6' },
    ]
    const perPage = ref(5)
    const total = ref(0)
    const currentPage = ref(1)
    const MODULE_NAME = 'statistic'
    return {
      MODULE_NAME,
      fields,
      perPage,
      total,
      currentPage,
    }
  },
}
</script>

<style scoped>

</style>
